import { withStyles } from "@material-ui/core/styles";
import ListCustom from "./ListCustom";
import styles from "./styles";

export default withStyles(styles)(ListCustom);
